import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setToogleHeader } from '../../core/redux/action';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import dayjs from 'dayjs';
import Select from 'react-select';
import { DatePicker } from 'antd';
import {
  ChevronUp,
  RotateCcw,
 
  Search,
  Download,
  Printer,
  Eye,
  Edit,
  
  AlertTriangle,
  CheckCircle,
  XCircle,
  TrendingUp,
  TrendingDown,
  Package,
 
  RefreshCw
} from 'feather-icons-react/build/IconComponents';
import { stockActions } from '../../core/action/stockaction';
import { productActions } from '../../core/action/productActions-bkf-1';

const StockManagement = () => {
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const data = useSelector((state) => state.toggle_header);

  // State
  const [products, setProducts] = useState([]);
  const [stockMovements, setStockMovements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  //const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [viewMode, setViewMode] = useState('summary'); // 'summary' or 'movements'

  // Filter states
  const [filters, setFilters] = useState({
    search: '',
    category: '',
    brand: '',
    stockStatus: 'all', // 'all', 'low', 'out', 'in'
    dateFrom: null,
    dateTo: null,
    movementType: 'all' // 'all', 'purchase_in', 'sale_out', 'return', 'adjustment'
  });

  // Dropdown options
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  //const [units, setUnits] = useState([]);

  // Pagination
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 1
  });

  // Stock status options
  const stockStatusOptions = [
    { value: 'all', label: 'All Stock' },
    { value: 'in_stock', label: 'In Stock' },
    { value: 'low_stock', label: 'Low Stock' },
    { value: 'out_of_stock', label: 'Out of Stock' }
  ];

  // Movement type options
  const movementTypeOptions = [
    { value: 'all', label: 'All Movements' },
    { value: 'purchase_in', label: 'Purchase In' },
    { value: 'sale_out', label: 'Sale Out' },
    { value: 'purchase_return', label: 'Purchase Return' },
    { value: 'adjustment', label: 'Stock Adjustment' },
    { value: 'opening_stock', label: 'Opening Stock' }
  ];

  // Sort options
  const sortOptions = [
    { value: 'name_asc', label: 'Product Name (A-Z)' },
    { value: 'name_desc', label: 'Product Name (Z-A)' },
    { value: 'stock_asc', label: 'Stock (Low to High)' },
    { value: 'stock_desc', label: 'Stock (High to Low)' },
    { value: 'price_asc', label: 'Price (Low to High)' },
    { value: 'price_desc', label: 'Price (High to Low)' },
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' }
  ];

  const [sortOption, setSortOption] = useState('name_asc');

  // Initialize
  useEffect(() => {
    loadInitialData();
    loadStockSummary();
  }, []);

  // Load categories, brands, units
  const loadInitialData = async () => {
    try {
      const [categoriesRes, brandsRes] = await Promise.all([
        productActions.getCategories(),
        productActions.getBrands(),
        //productActions.getUnits()
      ]);

      if (categoriesRes.success) {
        setCategories([
          { value: '', label: 'All Categories' },
          ...categoriesRes.data.map(cat => ({
            value: cat.id,
            label: cat.category_name || cat.name
          }))
        ]);
      }

      if (brandsRes.success) {
        setBrands([
          { value: '', label: 'All Brands' },
          ...brandsRes.data.map(brand => ({
            value: brand.id,
            label: brand.brand_name || brand.name
          }))
        ]);
      }

      // if (unitsRes.success) {
      //   setUnits([
      //     { value: '', label: 'All Units' },
      //     ...unitsRes.data.map(unit => ({
      //       value: unit.id,
      //       label: unit.unit_name || unit.name
      //     }))
      //   ]);
      // }
    } catch (error) {
      console.error('Error loading initial data:', error);
    }
  };

  // Load stock summary
  const loadStockSummary = async (page = 1) => {
    try {
      setLoading(true);
      
      const params = {
        page,
        limit: pagination.limit,
        search: filters.search,
        category_id: filters.category || undefined,
        brand_id: filters.brand || undefined,
        stock_status: filters.stockStatus !== 'all' ? filters.stockStatus : undefined,
        sort: sortOption
      };

      const result = await stockActions.getStockSummary(params);
      debugger;
      if (result.success) {
        setProducts(result.data || []);
        setPagination({
          page: result.page || page,
          limit: pagination.limit,
          total: result.total || 0,
          totalPages: result.totalPages || 1
        });
      }
    } catch (error) {
      console.error('Error loading stock summary:', error);
      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load stock data',
        timer: 2000
      });
    } finally {
      setLoading(false);
    }
  };

  // Load stock movements for a product
  const loadStockMovements = async (productId, page = 1) => {
    try {
      setLoading(true);
      
      const params = {
        product_id: productId,
        page,
        limit: 20,
        from_date: filters.dateFrom ? dayjs(filters.dateFrom).format('YYYY-MM-DD') : undefined,
        to_date: filters.dateTo ? dayjs(filters.dateTo).format('YYYY-MM-DD') : undefined,
        type: filters.movementType !== 'all' ? filters.movementType : undefined
      };

      const result = await stockActions.getStockMovements(params);
      
      if (result.success) {
        setStockMovements(result.data || []);
        setSelectedProduct(products.find(p => p.id === productId));
        setViewMode('movements');
      }
    } catch (error) {
      console.error('Error loading stock movements:', error);
      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load stock movements',
        timer: 2000
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle product click to view movements
  const handleViewMovements = (product) => {
    loadStockMovements(product.id);
  };

 // Handle adjust stock
const handleAdjustStock = (product) => {
  MySwal.fire({
    title: 'Adjust Stock',
    html: `
      <div class="text-start">
        <p><strong>Product:</strong> ${product.product_name}</p>
        <p><strong>Current Stock:</strong> ${product.current_stock} ${product.unit}</p>
        <hr>
        <div class="mb-3">
          <label class="form-label">Adjustment Type</label>
          <select id="adjustment-type" class="form-select">
            <option value="add">Add Stock (+)</option>
            <option value="remove">Remove Stock (-)</option>
            <option value="set">Set to Exact Quantity</option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label">Quantity</label>
          <input type="number" id="adjustment-qty" class="form-control" min="0" step="0.01" value="0">
        </div>
        <div class="mb-3">
          <label class="form-label">Reason</label>
          <input type="text" id="adjustment-reason" class="form-control" placeholder="e.g., Physical count, Damaged, etc.">
        </div>
        <div class="mb-3">
          <label class="form-label">Reference No.</label>
          <input type="text" id="adjustment-ref" class="form-control" placeholder="Optional">
        </div>
      </div>
    `,
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Update Stock',
    cancelButtonText: 'Cancel',
    preConfirm: () => {
      const type = document.getElementById('adjustment-type').value;
      const qty = parseFloat(document.getElementById('adjustment-qty').value) || 0;
      const reason = document.getElementById('adjustment-reason').value;
      const reference = document.getElementById('adjustment-ref').value;

      if (qty <= 0 && type !== 'set') {
        Swal.showValidationMessage('Quantity must be greater than 0');
        return false;
      }

      return { type, qty, reason, reference };
    }
  }).then(async (swalResult) => {
    if (swalResult.isConfirmed) {
      try {
        setLoading(true);
        
        const { type, qty, reason, reference } = swalResult.value;
        
        let adjustmentQty = qty;
        
        if (type === 'remove') {
          adjustmentQty = -qty;
        } else if (type === 'set') {
          adjustmentQty = qty - product.current_stock;
        }

        const adjustmentData = {
          product_id: product.id,
          quantity: adjustmentQty,
          type: 'adjustment',
          reason: reason || 'Manual stock adjustment',
          reference_no: reference || `ADJ-${Date.now()}`,
          notes: `Adjusted from ${product.current_stock} to ${type === 'set' ? qty : product.current_stock + adjustmentQty}`,
          created_by: 'Admin'
        };

        console.log('Sending adjustment data:', adjustmentData);
        
        const adjustResult = await stockActions.adjustStock(adjustmentData);
        
        if (adjustResult.success) {
          MySwal.fire({
            icon: 'success',
            title: 'Stock Adjusted!',
            text: 'Stock has been updated successfully',
            timer: 2000
          });
          loadStockSummary(pagination.page);
        } else {
          MySwal.fire({
            icon: 'error',
            title: 'Error',
            text: adjustResult.message || 'Failed to adjust stock',
            timer: 2000
          });
        }
      } catch (error) {
        console.error('Error adjusting stock:', error);
        MySwal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to adjust stock: ' + error.message,
          timer: 2000
        });
      } finally {
        setLoading(false);
      }
    }
  });
};
  // Handle back to summary
  const handleBackToSummary = () => {
    setViewMode('summary');
    setSelectedProduct(null);
    setStockMovements([]);
  };

  // Get stock status badge
  const getStockStatusBadge = (product) => {
    const currentStock = product.current_stock || 0;
    const alertQty = product.alert_quantity || 10;

    if (currentStock <= 0) {
      return {
        class: 'bg-danger',
        icon: <XCircle size={14} className="me-1" />,
        text: 'Out of Stock'
      };
    } else if (currentStock <= alertQty) {
      return {
        class: 'bg-warning text-dark',
        icon: <AlertTriangle size={14} className="me-1" />,
        text: `Low Stock (${currentStock})`
      };
    } else {
      return {
        class: 'bg-success',
        icon: <CheckCircle size={14} className="me-1" />,
        text: `In Stock (${currentStock})`
      };
    }
  };

  // Get movement type badge
  const getMovementTypeBadge = (type) => {
    switch (type) {
      case 'purchase_in':
        return { class: 'bg-success', icon: <TrendingUp size={14} />, text: 'Purchase In' };
      case 'sale_out':
        return { class: 'bg-danger', icon: <TrendingDown size={14} />, text: 'Sale Out' };
      case 'purchase_return':
        return { class: 'bg-warning', icon: <RefreshCw size={14} />, text: 'Return' };
      case 'adjustment':
        return { class: 'bg-info', icon: <Edit size={14} />, text: 'Adjustment' };
      case 'opening_stock':
        return { class: 'bg-secondary', icon: <Package size={14} />, text: 'Opening' };
      default:
        return { class: 'bg-secondary', icon: <Package size={14} />, text: type };
    }
  };

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(amount || 0);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return dayjs(dateString).format('DD/MM/YYYY HH:mm');
  };

  // Calculate stock value
  const calculateStockValue = (product) => {
    return (product.current_stock || 0) * (product.cost_price || 0);
  };

  // Calculate summary statistics
  const getSummaryStats = () => {
    const stats = {
      totalProducts: products.length,
      totalItems: 0,
      totalValue: 0,
      lowStockCount: 0,
      outOfStockCount: 0
    };

    products.forEach(p => {
      stats.totalItems += p.current_stock || 0;
      stats.totalValue += calculateStockValue(p);
      
      if ((p.current_stock || 0) <= 0) {
        stats.outOfStockCount++;
      } else if ((p.current_stock || 0) <= (p.alert_quantity || 10)) {
        stats.lowStockCount++;
      }
    });

    return stats;
  };

  const stats = getSummaryStats();

  // Tooltip renderer
  const renderTooltip = (props, text) => (
    <Tooltip id={`tooltip-${text}`} {...props}>{text}</Tooltip>
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Header */}
        <div className="page-header">
          <div className="page-title">
            <h4>Stock Management</h4>
            <h6>
              {viewMode === 'summary' 
                ? 'Monitor and manage inventory levels' 
                : `Stock Movements - ${selectedProduct?.product_name}`
              }
            </h6>
          </div>

          <ul className="table-top-head">
            {viewMode === 'movements' && (
              <li>
                <button className="btn btn-outline-secondary" onClick={handleBackToSummary}>
                  <Package size={16} className="me-1" />
                  Back to Summary
                </button>
              </li>
            )}
            <li>
              <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Export')}>
                <Link onClick={() => window.print()}>
                  <Download />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Print')}>
                <Link onClick={() => window.print()}>
                  <Printer />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Refresh')}>
                <Link onClick={() => viewMode === 'summary' ? loadStockSummary() : loadStockMovements(selectedProduct?.id)}>
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Collapse')}>
                <Link
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        {viewMode === 'summary' ? (
          <>
            {/* Summary Cards */}
            <div className="row mb-4">
              <div className="col-xl-3 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h6 className="card-title text-muted">Total Products</h6>
                    <h3 className="mb-0">{stats.totalProducts}</h3>
                    <small className="text-muted">Active products</small>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h6 className="card-title text-muted">Total Items</h6>
                    <h3 className="mb-0">{stats.totalItems}</h3>
                    <small className="text-muted">Units in stock</small>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h6 className="card-title text-muted">Stock Value</h6>
                    <h3 className="mb-0 text-primary">{formatCurrency(stats.totalValue)}</h3>
                    <small className="text-muted">At cost price</small>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h6 className="card-title text-muted">Low/Out Stock</h6>
                    <h3 className="mb-0">
                      <span className="text-warning me-2">{stats.lowStockCount} Low</span>
                      <span className="text-danger">{stats.outOfStockCount} Out</span>
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            {/* Filters */}
            <div className="card mb-4">
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label className="form-label">Search</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Product name, SKU..."
                          value={filters.search}
                          onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
                          onKeyPress={(e) => e.key === 'Enter' && loadStockSummary(1)}
                        />
                        <button className="btn btn-primary" onClick={() => loadStockSummary(1)}>
                          <Search size={16} />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="mb-3">
                      <label className="form-label">Category</label>
                      <Select
                        options={categories}
                        value={categories.find(c => c.value === filters.category)}
                        onChange={(opt) => setFilters(prev => ({ ...prev, category: opt?.value || '' }))}
                        isClearable
                      />
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="mb-3">
                      <label className="form-label">Brand</label>
                      <Select
                        options={brands}
                        value={brands.find(b => b.value === filters.brand)}
                        onChange={(opt) => setFilters(prev => ({ ...prev, brand: opt?.value || '' }))}
                        isClearable
                      />
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="mb-3">
                      <label className="form-label">Stock Status</label>
                      <Select
                        options={stockStatusOptions}
                        value={stockStatusOptions.find(s => s.value === filters.stockStatus)}
                        onChange={(opt) => setFilters(prev => ({ ...prev, stockStatus: opt?.value || 'all' }))}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label className="form-label">Sort By</label>
                      <Select
                        options={sortOptions}
                        value={sortOptions.find(s => s.value === sortOption)}
                        onChange={(opt) => {
                          setSortOption(opt?.value || 'name_asc');
                          loadStockSummary(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <button className="btn btn-primary me-2" onClick={() => loadStockSummary(1)}>
                      Apply Filters
                    </button>
                    <button className="btn btn-secondary" onClick={() => {
                      setFilters({
                        search: '',
                        category: '',
                        brand: '',
                        stockStatus: 'all',
                        dateFrom: null,
                        dateTo: null,
                        movementType: 'all'
                      });
                      setSortOption('name_asc');
                      loadStockSummary(1);
                    }}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Stock Summary Table */}
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Product</th>
                        <th>SKU</th>
                        <th>Category</th>
                        <th>Brand</th>
                        <th>Unit</th>
                        <th className="text-end">Current Stock</th>
                        <th className="text-end">Cost Price</th>
                        <th className="text-end">Selling Price</th>
                        <th className="text-end">Stock Value</th>
                        <th>Status</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </td>
                        </tr>
                      ) : products.length === 0 ? (
                        <tr>
                          <td colSpan="12" className="text-center py-4">
                            <p className="text-muted mb-0">No products found</p>
                          </td>
                        </tr>
                      ) : (
                        products.map((product, index) => {
                          const status = getStockStatusBadge(product);
                          return (
                            <tr key={product.id}>
                              <td>{((pagination.page - 1) * pagination.limit) + index + 1}</td>
                              <td>
                                <Link to={`/product/${product.id}`} className="fw-bold">
                                  {product.product_name}
                                </Link>
                              </td>
                              <td>
                                <span className="badge bg-light text-dark">{product.sku}</span>
                              </td>
                              <td>{product.category_name || '-'}</td>
                              <td>{product.brand_name || '-'}</td>
                              <td>{product.unit || 'Pcs'}</td>
                              <td className="text-end fw-bold">{product.current_stock || 0}</td>
                              <td className="text-end">{formatCurrency(product.cost_price)}</td>
                              <td className="text-end">{formatCurrency(product.selling_price)}</td>
                              <td className="text-end text-primary fw-bold">
                                {formatCurrency(calculateStockValue(product))}
                              </td>
                              <td>
                                <span className={`badge ${status.class}`}>
                                  {status.icon} {status.text}
                                </span>
                              </td>
                              <td className="text-center">
                                <button
                                  className="btn btn-sm btn-outline-info me-1"
                                  onClick={() => handleViewMovements(product)}
                                  title="View Movements"
                                >
                                  <Eye size={14} />
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-warning"
                                  onClick={() => handleAdjustStock(product)}
                                  title="Adjust Stock"
                                >
                                  <Edit size={14} />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {pagination.totalPages > 1 && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {((pagination.page - 1) * pagination.limit) + 1} to{' '}
                      {Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total}
                    </div>
                    <nav>
                      <ul className="pagination">
                        <li className={`page-item ${pagination.page === 1 ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => loadStockSummary(pagination.page - 1)}
                          >
                            Previous
                          </button>
                        </li>
                        {[...Array(Math.min(5, pagination.totalPages))].map((_, i) => {
                          let pageNum = pagination.page;
                          if (pagination.totalPages <= 5) {
                            pageNum = i + 1;
                          } else if (pagination.page <= 3) {
                            pageNum = i + 1;
                          } else if (pagination.page >= pagination.totalPages - 2) {
                            pageNum = pagination.totalPages - 4 + i;
                          } else {
                            pageNum = pagination.page - 2 + i;
                          }
                          return (
                            <li key={pageNum} className={`page-item ${pagination.page === pageNum ? 'active' : ''}`}>
                              <button className="page-link" onClick={() => loadStockSummary(pageNum)}>
                                {pageNum}
                              </button>
                            </li>
                          );
                        })}
                        <li className={`page-item ${pagination.page === pagination.totalPages ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => loadStockSummary(pagination.page + 1)}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          /* Stock Movements View */
          <div className="card">
            <div className="card-header bg-light">
              <h5 className="mb-0">{selectedProduct?.product_name} - Stock Movements</h5>
            </div>
            <div className="card-body">
              {/* Product Info */}
              <div className="row mb-4">
                <div className="col-md-3">
                  <div className="card bg-light">
                    <div className="card-body">
                      <small className="text-muted d-block">SKU</small>
                      <strong>{selectedProduct?.sku}</strong>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-light">
                    <div className="card-body">
                      <small className="text-muted d-block">Current Stock</small>
                      <strong>{selectedProduct?.current_stock} {selectedProduct?.unit}</strong>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-light">
                    <div className="card-body">
                      <small className="text-muted d-block">Cost Price</small>
                      <strong>{formatCurrency(selectedProduct?.cost_price)}</strong>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card bg-light">
                    <div className="card-body">
                      <small className="text-muted d-block">Selling Price</small>
                      <strong>{formatCurrency(selectedProduct?.selling_price)}</strong>
                    </div>
                  </div>
                </div>
              </div>

              {/* Movement Filters */}
              <div className="row mb-4">
                <div className="col-md-4">
                  <label className="form-label">Date Range</label>
                  <div className="d-flex gap-2">
                    <DatePicker
                      className="form-control"
                      value={filters.dateFrom}
                      onChange={(date) => setFilters(prev => ({ ...prev, dateFrom: date }))}
                      format="DD-MM-YYYY"
                      placeholder="From Date"
                    />
                    <DatePicker
                      className="form-control"
                      value={filters.dateTo}
                      onChange={(date) => setFilters(prev => ({ ...prev, dateTo: date }))}
                      format="DD-MM-YYYY"
                      placeholder="To Date"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Movement Type</label>
                  <Select
                    options={movementTypeOptions}
                    value={movementTypeOptions.find(m => m.value === filters.movementType)}
                    onChange={(opt) => setFilters(prev => ({ ...prev, movementType: opt?.value || 'all' }))}
                  />
                </div>
                <div className="col-md-4 d-flex align-items-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={() => loadStockMovements(selectedProduct?.id)}
                  >
                    Apply Filters
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setFilters(prev => ({
                        ...prev,
                        dateFrom: null,
                        dateTo: null,
                        movementType: 'all'
                      }));
                      loadStockMovements(selectedProduct?.id);
                    }}
                  >
                    Reset
                  </button>
                </div>
              </div>

              {/* Movements Table */}
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Type</th>
                      <th className="text-end">Quantity</th>
                      <th className="text-end">Stock Before</th>
                      <th className="text-end">Stock After</th>
                      <th>Reference</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="8" className="text-center py-4">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : stockMovements.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center py-4">
                          <p className="text-muted mb-0">No stock movements found</p>
                        </td>
                      </tr>
                    ) : (
                      stockMovements.map((movement, index) => {
                        const badge = getMovementTypeBadge(movement.type);
                        return (
                          <tr key={movement.id}>
                            <td>{index + 1}</td>
                            <td>{formatDate(movement.created_at)}</td>
                            <td>
                              <span className={`badge ${badge.class}`}>
                                {badge.icon} {badge.text}
                              </span>
                            </td>
                            <td className={`text-end fw-bold ${movement.quantity > 0 ? 'text-success' : 'text-danger'}`}>
                              {movement.quantity > 0 ? '+' : ''}{movement.quantity}
                            </td>
                            <td className="text-end">{movement.stock_before}</td>
                            <td className="text-end">{movement.stock_after}</td>
                            <td>
                              {movement.reference_no ? (
                                <span className="badge bg-light text-dark">{movement.reference_no}</span>
                              ) : '-'}
                            </td>
                            <td>
                              <span className="text-muted small" title={movement.notes}>
                                {movement.notes?.length > 30
                                  ? `${movement.notes.substring(0, 30)}...`
                                  : movement.notes || '-'
                                }
                              </span>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StockManagement;